import React, { useEffect, useState } from "react";
import pdf1 from "../../../../../src/assets/images/pdf.svg";
import download from "../../../../../src/assets/images/download1.svg";
import download1 from "../../../../../src/assets/images/download2.svg";
import { Aed } from "../../../common/Money";

// TIP-489/493 (MV) — what customers pay for is Membership, and the web-profile
// subscription type is shown as "Web Profile". Map the internal type to a
// customer-facing label.
const TYPE_LABELS = { verified: "Membership", "pay-as-you-go": "Web Profile", brief_purchase: "Counterparty Briefs" };
export const planLabel = (subs) =>
  subs?.PaymentIntentID
    ? "Membership"
    : TYPE_LABELS[subs?.subscription_type] || subs?.subscription_type;

const BillingComponent = ({
  data,
  onDownloadInvoice,
  onDownloadInvoiceAll,
  getSubAmount,
  cancelled,
  setGetConfirm,
  activeSub,
}) => {
  const [billingData, setBillingData] = useState([]);

  useEffect(()=>{
    setBillingData(data?.filter(b => b.subscription_type !== "freemium"));
  },[data])
  return (
    <>
      <div className="w-full py-4 flex flex-col items-start gap-24 rounded-8 bg-white">
        <div className="w-full">
          <div className="px-8 w-full flex justify-between items-center">
            <div className="flex flex-col items-start">
              <h1 className="text-f20 font-bold text-[#012234]">
                Billing History
              </h1>
              <p className="text-f14 w-max">
                All your payments will be visible here
              </p>
            </div>
            <img
              onClick={onDownloadInvoiceAll}
              src={download}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded cursor-pointer"
              alt="Download Icon"
            />
          </div>

          <div className="bg-white w-full rounded-md mt-6">
            <table className="w-full">
              <thead className="border-t-2 text-f12 text-left items-start">
                <tr>
                  <th className="py-2 px-12 border-b-2">Invoice</th>
                  <th className="py-2 px-12 border-b-2 w-36">Paid On</th>
                  <th className="py-2 px-12 border-b-2">Amount</th>
                  <th className="py-2 px-12 border-b-2">Product</th>
                  <th className="py-2 px-12 border-b-2">Action</th>
                </tr>
              </thead>

              <tbody className="mt-[20px]">
                {billingData && billingData?.length > 0 ? (
                  <>
                    {billingData?.map((subs) => (
                      <tr className="border-t border-b">
                        <td className="py-2 px-8 border-b text-f12 flex w-max items-center">
                          <div className="flex text-start items-center justify-start text-f12">
                            <img
                              className="w-6 h-6 mr-2 "
                              src={pdf1}
                              alt="PDF Logo"
                            />
                            {subs?.invoice?.slice(29)}
                          </div>
                          Invoice_{" "}
                          {new Date(subs?.date_of_start).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </td>
                        <td className="py-2 px-8 border-b text-f12 w-max">
                          {/* TIP-556 — created_at carries the purchase time; rows
                              older than the field show date-only (time unknown). */}
                          {subs?.created_at
                            ? new Date(subs.created_at).toLocaleString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                              })
                            : new Date(subs?.date_of_start).toLocaleDateString(
                                "en-US",
                                {
                                  month: "short",
                                  day: "numeric",
                                  year: "numeric",
                                }
                              )}
                        </td>
                        <td className="py-2 px-8 border-b text-f12">
                          <Aed value={subs?.amount ? subs?.amount : getSubAmount(subs?.subscription_type)} />
                        </td>
                        <td className="py-2 px-8 border-b text-start text-f12 capitalize w-44">
                          {planLabel(subs)}
                        </td>
                        <td className="py-2 px-8 border-b text-f12">
                          {/* TIP-556 — the TREVEX-generated tax invoice (served from
                              S3 via the masked download) is the primary document;
                              the Stripe-hosted receipt is only a fallback for rows
                              whose PDF was never generated. */}
                          <img
                            onClick={() => onDownloadInvoice(subs?.trevex_invoice || subs?.invoice_url)}
                            src={download1}
                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded cursor-pointer"
                            alt="Download Icon"
                            title={subs?.trevex_invoice ? "Download TREVEX tax invoice" : "Download Stripe receipt"}
                          />
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr className="border-t border-b">
                    <td className="py-2 px-8 border-b" colSpan={5}>
                      <div className="flex text-start items-center justify-center text-f12">
                        No Data Found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/* TIP-464 — Hide the in-app Cancel button for verified subs. The
          legacy CancelSubscription endpoint has a pre-existing auth bug
          (always returns 403; tracked in TIP-470) so cancelling through
          here doesn't work anyway. Verified subs route cancellation
          through Stripe Customer Portal via the "Manage subscription"
          button on the active-plan card — Stripe handles the cancel-at-
          period-end + fires customer.subscription.deleted webhook. Once
          TIP-470 lands we can drop this guard. */}
      {activeSub?.subscription_type !== "verified" && (
        <button
          disabled={
            cancelled === "Cancel Subscription Successfully" ||
            cancelled === "cancelled" ||
            cancelled === "No Subscription"
          }
          onClick={() =>
            cancelled === "Cancel Subscription Successfully" ||
              cancelled === "cancelled" ||
              cancelled === "No Subscription"
              ? null
              : setGetConfirm(true)
          }
          className="text-link flex items-end mt-10 mb-5 text-f14 font-semibold"
        >
          {!activeSub || activeSub?.subscription_type === "pay-as-you-go"
            ? ""
            : cancelled === "Cancel Subscription Successfully" ||
              cancelled === "cancelled"
              ? "Subscription is Cancelled"
              : "Cancel Subscription"}
        </button>
      )}
    </>
  );
};

export default BillingComponent;
